import {
  formatTogetherCommunity,
  formatTogetherPostV2,
  formatTogetherTopic,
} from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { callApi, callApiWithAuth, getTogetherPath } from 'api/utils'
import dayjs from 'dayjs'
import {
  TogetherCommunity,
  TogetherPostApiV2,
  TogetherPostV2,
  TogetherTopic,
  TogetherTopicApi,
} from 'interfaces/types'

export const getCommunityInfo = async (
  query: Record<string, any>,
  fetchFunction: typeof callApi | typeof callApiWithAuth,
) => {
  const communityRes = await fetchFunction(
    getTogetherPath(PATHS.GET_TOGETHER_COMMUNITY_DETAIL, query),
    'GET',
  )

  return communityRes?.data
    ? formatTogetherCommunity(communityRes?.data)
    : ({} as TogetherCommunity)
}

export const getTopicInfo = async (
  query: Record<string, any>,
  fetchFunction: typeof callApi | typeof callApiWithAuth,
) => {
  const topicsRequest = await fetchFunction(
    getTogetherPath(PATHS.GET_TOGETHER_TOPICS, query),
    'get',
  )

  return (
    (topicsRequest?.data?.topics?.map((topic: TogetherTopicApi) =>
      formatTogetherTopic(topic),
    ) as TogetherTopic[]) || []
  ).filter((e) => e?.isActive)
}

export const getPostList = async (
  query: Record<string, any>,
  fetchFunction: typeof callApi | typeof callApiWithAuth,
) => {
  const { articleId, ...restQuery } = query
  try {
    const [guestPostsRequestByArticle, guestPostsRequest] = await Promise.all([
      fetchFunction(
        getTogetherPath(PATHS.GET_TOGETHER_POST_LIST, {
          ...restQuery,
          articleId,
          sortBy: 'popularity',
          postBy: 'member',
        }),
        'GET',
      ),
      fetchFunction(
        getTogetherPath(PATHS.GET_TOGETHER_POST_LIST, {
          ...restQuery,
          reportStartDate: dayjs().subtract(2, 'month').format('YYYY-MM-DD'),
          reportEndDate: dayjs().format('YYYY-MM-DD'),
          sortBy: 'popularity',
          postBy: 'member',
        }),
        'GET',
      ),
    ])
    const currentPostsList = guestPostsRequestByArticle?.data?.posts
    // Don't have enough article to show
    if (currentPostsList?.length < 5) {
      return (
        (guestPostsRequest?.data?.posts?.map((post: TogetherPostApiV2) =>
          formatTogetherPostV2(post),
        ) as TogetherPostV2[]) || []
      )
    } else {
      return (
        (currentPostsList?.map((post: TogetherPostApiV2) =>
          formatTogetherPostV2(post),
        ) as TogetherPostV2[]) || []
      )
    }
  } catch (err) {
    return []
  }
}
